import { render } from "./audit.vue?vue&type=template&id=bd67dff8&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"

import "./audit.vue?vue&type=style&index=0&id=bd67dff8&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd67dff8"]])

export default __exports__